
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import { AtsCompany } from "@/lib/model/NRXQ/nr";
import request from "@/lib/request/request";

@Component({
  components: {}
})
export default class AtsDetailTable extends Vue {
  @Prop({ default: [], type: Array }) tableData!: [];
  @Prop({ default: 0, type: Number }) status!: number;
  atsCompanyList?: AtsCompany[] = [];
  a = 0;

  showSetIsNrDialog = false;
  showSetIsNrDialogStatus = 0;
  setNrCv: any = null;

  @Watch("status")
  as(o: any, k: any) {
    this.a = Number(o);
  }

  tableShowData: any[] = []; //表格展示用数据
  created() {
    //
  }
  mounted() {
    this.tableData.forEach((d: any) => {
      this.tableShowData.push(d.atsCv);
    });
  }

  // 显示加入移出牛人推弹窗
  showSetIsNR(cv: any, status: number) {
    this.showSetIsNrDialog = true;
    this.showSetIsNrDialogStatus = status;
    this.setNrCv = cv;
  }

  // 确认加入移出牛人推
  confirmSetIsNr() {
    request
      .post("/aiExam/atsAdmin/cvSetNr", {
        atsCvId: this.setNrCv.atsCvId,
        isNr: this.showSetIsNrDialogStatus
      })
      .then(res => {
        if (res.data.code === 0) {
          this.setNrCv.isNr = this.showSetIsNrDialogStatus;
          this.showSetIsNrDialog = false;
        }
      });
  }

  showDetail(scope: any) {
    this.$emit("showDetail", scope.row || scope);
  }
  companyName(companyId: any) {
    if (this.atsCompanyList) {
      for (const item of this.atsCompanyList) {
        if (item.atsCompanyId == companyId) {
          return item.name;
        }
      }
    }
    return "-";
  }

  getSubmitStatusName(i: any): string {
    let statusText = "";
    i = Number(i);
    switch (i) {
      case 0:
        statusText = "未登记";
        break;
      case 1:
        statusText = "答题中";
        break;
      case 2:
        statusText = "已交卷";
        break;
      case 3:
        statusText = "已登记";
        break;
    }
    return statusText;
  }

  auditStatusConvert(auditStatus: any) {
    auditStatus = Number(auditStatus);
    if (auditStatus === 0) {
      return "待评估";
    } else if (auditStatus === 1) {
      return "通过";
    } else if (auditStatus === 2) {
      return "待定";
    } else if (auditStatus === 3) {
      return "拒绝";
    } else {
      return "待评估";
    }
  }
}
